import { ComparisonOperator, Field } from "../vforms-model";

export class ComparisonExpression {
    field: Field | undefined;
    operator: ComparisonOperator | undefined;
    value: any | undefined;
}

//And over conditions
export class Expression {
    conditions: ComparisonExpression[];

    constructor() {
        this.conditions = [new ComparisonExpression()];
    }

    newCondition() {
        this.conditions.push(new ComparisonExpression());
    }

    removeCondition(condition: ComparisonExpression) {
        this.conditions.splice(this.conditions.indexOf(condition), 1);
    }

    isEmpty() {
        return this.conditions.length === 0;
    }
    count() {
        return this.conditions.length;
    }
}

//Or over expressions
export class Predicate {
    expressions: Expression[];

    constructor() {
        this.expressions = [new Expression()];
    }

    newExpression() {
        this.expressions.push(new Expression());
    }

    removeCondition(expression: Expression, condition: ComparisonExpression) {
        let allowDeleteCondition = this.expressions.length > 1 || expression.count() > 1;
        if (allowDeleteCondition) {
            expression.removeCondition(condition);
        }

        if (expression.isEmpty()) {
            this.expressions.splice(this.expressions.indexOf(expression), 1);
        }
    }
}

export enum Action {
    Hide = "hide",
    Display = "display",
    Disable = "disable",
    Enable = "enable",
}

export class FieldAction {
    action: Action | undefined;
    field: Field | undefined;
}

export class Conditional {
    name: string;
    predicate: Predicate;
    positiveActions: FieldAction[];
    negativeActions: FieldAction[];

    constructor() {
        this.predicate = new Predicate();
        this.positiveActions = [new FieldAction()];
        this.negativeActions = [new FieldAction()];
    }

    defaultActions() {
        this.positiveActions.push(new FieldAction());
        this.negativeActions.push(new FieldAction());
    }

    isValid(): boolean {
        let positiveActions = this.positiveActions.filter((a) => !!a.field);
        let negativeActions = this.negativeActions.filter((a) => !!a.field);
        return this.name && this.name.length > 0 && positiveActions.length + negativeActions.length > 0;
    }

    removeDefaultActions(): boolean {
        this.positiveActions = this.positiveActions.filter((a) => !!a.field);
        this.negativeActions = this.negativeActions.filter((a) => !!a.field);
        return this.positiveActions.length + this.negativeActions.length > 0;
    }

    newPositiveAction() {
        this.positiveActions.push(new FieldAction());
    }

    removePositiveAction(fieldAction: FieldAction) {
        if (this.positiveActions.length + this.negativeActions.length > 1) {
            this.positiveActions.splice(this.positiveActions.indexOf(fieldAction), 1);
        }
    }

    newNegativeAction() {
        this.negativeActions.push(new FieldAction());
    }

    removeNegativeAction(fieldAction: FieldAction) {
        if (this.positiveActions.length + this.negativeActions.length > 1) {
            this.negativeActions.splice(this.negativeActions.indexOf(fieldAction), 1);
        }
    }
}
